import types from '../../actions.types';

const { ROUTE_DETAILS } = types.routeDetails;

const defaultState = {
  data: {}
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case ROUTE_DETAILS:
      return Object.assign({}, state, {
        data: action.data
      });
    default:
      return state;
  }
}